export const CONVERSATION_LABEL_DOT_CLASSES = {
  blue: "bg-blue-500",
  green: "bg-green-500",
  yellow: "bg-yellow-400",
  red: "bg-red-500",
  purple: "bg-purple-500",
  pink: "bg-pink-500",
  indigo: "bg-indigo-500",
  gray: "bg-gray-400",
};

export function getConversationLabelDotClass(color) {
  return CONVERSATION_LABEL_DOT_CLASSES[color] || CONVERSATION_LABEL_DOT_CLASSES.gray;
}

export function findConversationLabel(statuses = [], statusId = null) {
  if (!statusId) return null;
  return statuses.find((status) => status?.id === statusId) || null;
}

function hasConversationStatus(value) {
  return typeof value === "string" && value.trim().length > 0;
}

export function mergeConversationRowsForRefresh(previousRows = [], incomingRows = []) {
  const previousByUser = new Map(
    previousRows
      .filter((row) => row?.utilisateur)
      .map((row) => [row.utilisateur, row])
  );

  return incomingRows.map((row) => {
    const previous = previousByUser.get(row?.utilisateur);
    if (
      previous &&
      hasConversationStatus(previous.conversation_status) &&
      !hasConversationStatus(row?.conversation_status)
    ) {
      return {
        ...row,
        conversation_status: previous.conversation_status,
      };
    }
    return row;
  });
}
